<template>
    <div>
        <v-container class="mt-2 mx-auto px-7" :class="{'justify-center': pcOnly}">

            <v-card class="form-wrapper soft-shadow">
                <div class="mx-auto text-center mt-2 pa-1">
                    <logo :width="160" :link="false" />
                </div>
                <!-- <v-card-title class="pt-0 text-center justify-center mb-1">تسجيل دخول  المعلم</v-card-title> -->
                <v-card-subtitle class="text-center pt-0 mb-6">تسجيل الدخول إلى لوحة المعلم</v-card-subtitle>

                <!-- <v-divider class="my-3 mx-4" /> -->
                <v-card-text>
                    <form @submit.prevent="login">
                        <v-text-field autofocus placeholder="أدخل البريد اﻹلكتروني" label="البريد الإلكتروني" name="email" v-model="email" :loading="loading" :disabled="loading" outlined hide-details></v-text-field>
                        <v-text-field placeholder="أدخل كلمة المرور" label="كلمة المرور" outlined name="password" hide-details v-model="password" :loading="loading" :disabled="loading" class="my-5" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"></v-text-field>
                        <div v-if="false" class="d-flex justify-space-between align-center mb-4">
                            <div>
                                <v-checkbox v-model="remember" :disabled="loading" label="تذكر حسابي" class="ma-0" hide-details></v-checkbox>
                            </div>
                            <div>
                                <!-- <v-btn text dense to="/reset-password" :disabled="loading" class="forget-password grey--text px-2">نسيت كلمة المرور؟</v-btn> -->
                            </div>
                        </div>
                        <v-btn type="submit" block depressed large :disabled="loading" color="primary" @click.prevent="login" class="mt-6 mt-lg-8">تسجيل الدخول</v-btn>
                    </form>

                </v-card-text>
            </v-card>
        </v-container>

        <slot name="footer" />
    </div>
</template>

<script>

// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'login',
    data(){
        return {
            email: '',
            password: '',
            remember: true,
            loading: false,
            showPassword: false,
        };
    },
    components: {
        
    },
    computed:{
        ...GlobalComputed 
    },
    methods: {
        ...GlobalMethods,
        login(){
            let email = this.email,
                password = this.password,
                remember = this.remember;
                this.loginAction(email, password, remember);               
        },
        loginAction(email, password, remember = true){
             
            if (email && password){
                this.loading = true;
                
                this.$store.dispatch('loginAction', { email, password, remember }).then(()=>{
                    this.loading = false;
                    this.$router.push({name: 'home'});
                }).catch(error=>{
                    this.loading = false;
                    if (error.response && (error.response.status === 401)){
                        this.showLoginMsg('البريد الإلكتروني أو كلمة المرور غير صحيحة');
                    }else if (error.response && error.response.status === 422){
                        this.showLoginMsg('أدخل البيانات بشكل صحيح');
                    }else{
                        this.showLoginMsg('حدثت مشكلة أثناء تسجيل الدخول');
                    }
                })
            }else{
                this.showLoginMsg("لا يمكنك ترك حقول فارغة")
            }
        },
        showLoginMsg(msg){
            // this.showMsg(msg, 'error', true);
            this.showMsg(msg, 'error');
        },
        closeMsg(){
            if (this.$store.state.globalModule.snackMsg.text){
                this.$store.dispatch('addSnackMsg', {show: false, text: '', msgBar: true});
            }
        },
    },
    watch: {
        email(){
            this.closeMsg();
        },
        password(){
            this.closeMsg();
        }
    },
    mounted(){
        

    }
}
</script>

<style lang="scss" scoped>
    .logo-wrapper{
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .logo{
            max-width: 150px;
            min-width: 120px;
            height: auto;
        }
    }
    .social-btns{
        direction: ltr;
        display: flex;
        justify-content: space-between;
        margin: 1rem 0;
    }

</style>